//deskarista ylöspäin tuotekuvassa zoomaus

$('.nav-search-btn').on('click', function() {
  toggleShopSearchField();
});

$('.searchBackground').on('click', function() {
  toggleShopSearchField();
});

function toggleShopSearchField() {
  $('.nav-search').toggle();
  $('.menu-bottommenu-ammattilaisille-container').toggle();
  $('.nav-link-shop').toggle();
  //$('.nav-link-button').toggle();
  $('.nav-search-btn .showSearch').toggle();
  $('.nav-search-btn .closeSearch').toggle();
  $('.searchBackground').toggle();
}


// $('.tile')
// tile mouse actions
  // .on('mouseover', function(){
  //   if ($(window).width() > 1024) {
  //     //$(this).children('.photo').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
  //     var zoom = $(this).data('zoom');
  //     console.log(zoom);
  //     $(this).css({'height': + zoom });
  //     $(this).css({'height': '150%', 'width': '150%' });
  //   }
  // })
  // .on('mouseout', function(){
  //   if ($(window).width() > 1024) {
  //     $(this).css({'height': '100%', 'width': '100%' });
  //     //$(this).css({'height': '150%'});
  //     //$(this).children('.photo').css({'transform': 'scale(1)'});
  //   }
  // })
  // .on('mousemove', function(e){
  //   if ($(window).width() > 1024) {
  //     $(this).children('.photo').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
  //   }
  // })
  // tiles set up
  // .each(function(){
  //   $(this)
  //   // add a photo container
  //     .append('<div class="photo"></div>')
  //     // some text just to show zoom level on current item in this example
  //     //.append('<div class="txt"><div class="x">'+ $(this).attr('data-scale') +'x</div>ZOOM ON<br>HOVER</div>')
  //     // set up a background image for each tile based on data-image attribute
  //     .children('.photo').css({'background-image': 'url('+ $(this).attr('data-image') +')'});
  // })



// WEBPACK FOOTER //
// ./scripts/autoload/woocommerce.js